import React from 'react'
import { Label } from '@workwhile/ui'
import {
  JET_ALERT_STATUS_LABELS,
  JET_ALERT_STATUS_LABEL_VARIANTS,
} from 'pages/Jet/shared/constants/alertType'

// An alert is "active" while it has no resolvedAt (still firing each cron run).
export const JetAlertStatusBadge = ({
  resolvedAt,
}: {
  resolvedAt: string | null
}) => {
  const status = resolvedAt ? 'resolved' : 'active'

  return (
    <Label
      variant={JET_ALERT_STATUS_LABEL_VARIANTS[status]}
      size="small"
      style={{ whiteSpace: 'nowrap', padding: '0 0.5rem' }}
    >
      {JET_ALERT_STATUS_LABELS[status]}
    </Label>
  )
}
